import { Dispatch, SetStateAction } from "react";
import { Col, Row } from "reactstrap";
import AppFieldCard from "../../../elements/AppFieldCard";
import { Tenant } from "../../../types/GlobalInterfaces";
import GCSymbol from "assets/img/growthcloud/growthcloud_symbol.svg";

interface Clouds {
  clouds: Array<Tenant> | undefined;
  cloudsLoading: boolean;
  setTenantID: Dispatch<SetStateAction<string>> | undefined;
  tenantID: string | undefined;
}

const SelectCloud = ({
  clouds,
  cloudsLoading,
  setTenantID,
  tenantID,
}: Clouds) => {
  return (
    <>
      {cloudsLoading ? (
        <div>
          <Row>
            <Col>
              <h4 className="mb-1">Hang Tight...</h4>
              <p className="text-muted mb-0">
                We&apos;re fetching your clouds.
              </p>
            </Col>
          </Row>
        </div>
      ) : clouds && clouds.length ? (
        <>
          {clouds.map((c) => (
            <AppFieldCard
              key={c.id}
              onClick={
                setTenantID
                  ? () => {
                      setTenantID(c.id || "");
                    }
                  : undefined
              }
              isSelected={tenantID === c.id}
              icon={GCSymbol}
              name={c.Name}
              description={c.CompanyName}
              full
              css="mb-0"
              disabled={tenantID === c.id}
              innerCSS="mx-1"
              vectorIcon
            />
          ))}
        </>
      ) : (
        "No Clouds!"
      )}
    </>
  );
};

export default SelectCloud;
